import { AxiosResponse } from 'axios';
import { UDNICK } from 'service/udnick';

export interface TipoSolicitacao {
  codigo: number;
  descricao: string;
  exigeNota: boolean;
  show: string[];
}

interface Response {
  tiposSolicitacao: TipoSolicitacao[];
}

export const tipoSolicitacao = {
  getTiposSolicitacao: (): Promise<AxiosResponse<Response>> =>
    UDNICK.callService('getTiposSolicitacao'),
};
